/*
 * Copyright (c) 2018 Integral Agile, Inc. All rights reserved.
 *   Use of this file is subject to the terms and conditions defined in the file
 * 'LICENSE.txt'
 *   which is distributed in the root directory of this source code tree.
 */

import React from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import modalTypes from '../../constants/modalTypes';
import { openModal } from '../../actions/modalActions';
import { hyphenate } from '../../utils/string';
import StoryList from '../PlanWall/storyList';
import Holon from '../Buttons/holon';
import { formatDateSlash } from '../../utils/dateHelpers';

class DeploymentRow extends React.Component {
  constructor(props) {
    super(props);
    this.state = { visible: props.fromWall };
  }

  toggleVisibility = () => {
    this.setState(
      prevState => ({ visible: !prevState.visible }),
      this.saveComponentState
    );
  };

  openDeployment = () => {
    const { deployment } = this.props;

    this.props.openModal(modalTypes.deploymentDetail, { id: deployment.id });
  };

  panelHeading() {
    const { deployment } = this.props;
    const caret = this.state.visible
      ? 'glyphicon-triangle-bottom'
      : 'glyphicon-triangle-right';

    return (
      <div className="panel-title row">
        <div className="col-md-1" onClick={this.toggleVisibility}>
          <span className={`glyphicon ${caret}`} aria-hidden="true" />
        </div>
        <div className="col-md-4">
          <a onClick={this.openDeployment}>{deployment.short_name}</a>
        </div>
        <div className="col-md-2">
          <div className="center">
            <Holon />
          </div>
        </div>
        <div className="col-md-5 right">
          {formatDateSlash(deployment.deployment_date)}
        </div>
      </div>
    );
  }

  render() {
    const { deployment, results, showCompleted, add, remove } = this.props;

    if (!showCompleted && deployment.status === 'Completed') return null;

    const deletedClassName = deployment.deleted_at ? 'deleted' : '';

    return (
      <div
        className={`panel ${deployment.state &&
          hyphenate(deployment.state)} ${deletedClassName}`}
      >
        <div className="panel-heading">{this.panelHeading()}</div>
        <div className={`panel-body ${!this.state.visible && 'hide'}`}>
          <StoryList
            results={results}
            source={`card${deployment.id}`}
            parentId={deployment.id}
            add={add}
            delete={remove}
            mini
          />
        </div>
      </div>
    );
  }
}

DeploymentRow.propTypes = {
  deployment: PropTypes.object,
  preservedState: PropTypes.object,
  results: PropTypes.array,
  fromWall: PropTypes.bool,
  showCompleted: PropTypes.bool,
  add: PropTypes.func,
  remove: PropTypes.func,
  preserveComponentState: PropTypes.func
};

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      openModal
    },
    dispatch
  );

export default connect(
  null,
  mapDispatchToProps
)(DeploymentRow);
